import React, {useState} from 'react';
import UserDetails from './UserDetails';
import Lottie from 'lottie-react';
import loadingAnimation from '../../../../assets/lottie/loading.json';
import AccountStanding from "./account-standing/AccountStanding";

const Dashboard = () => {
  const [detailsLoaded, setDetailsLoaded] = useState(false);
  const [standingLoaded, setStandingLoaded] = useState(false);

  const allLoaded = detailsLoaded && standingLoaded;

  return (
      <>
        {/* Zentraler Loader: Verschwindet erst, wenn beide fertig sind */}
        {!allLoaded && (
            <div className="flex justify-center items-center h-[400px]">
              <Lottie animationData={loadingAnimation} loop className="w-64"/>
            </div>
        )}

        <div className={allLoaded ? 'block' : 'hidden'}>
          <UserDetails onLoaded={() => setDetailsLoaded(true)}/>
          <AccountStanding onLoaded={() => setStandingLoaded(true)}/>
        </div>
      </>
  );
};

export default Dashboard;